import { Component, OnInit, Input,OnDestroy,OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ControlService } from 'src/app/services/control/control.service';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';

declare var $:any;



@Component({
  selector: 'app-imprimir',
  templateUrl: './imprimir.component.html',
  styleUrls: ['./imprimir.component.css'],
  providers:[ImprimiService]
  
})
export class ImprimirComponent implements OnInit,OnDestroy,OnChanges{
 
    

    @Input() title:string;
    @Input() id:string;
    @Input() database:string;
    @Output() cerrarVentana = new EventEmitter();
    

    public anexo=new Date();
    public productos:any=[];
    public oldId="";
    public oldDatabase="";
    public productosKey:any[]=[];
    public estructurado:any[]=[];
    public fechaActual=this.fechaService.mostrarFechaActual();
    public closeWindow=true;
   
    constructor(private fechaService:FechasService,private controlService:ControlService,private imprimirService:ImprimiService){
            this.oldId=this.id;
    }
   public myMap=new Map([]);
    ngOnInit(): void {
      
        
       this.mostrarContenido();

       
    }
    ngOnDestroy(): void {
        
    }
    ngOnChanges(changes: SimpleChanges) {
        this.mostrarContenido();
       if(this.id){
        if(this.oldId !=this.id ){
            this.mostrarContenido();
        }
      
       }else{

       }
        
    }

    mostrarContenido(){
        this.imprimirService.getId(this.id,this.database).subscribe((resp:any)=>{
          
            this.productos=resp;

            //console.log("produc",this.productos);
         
            /* for (const key in this.productos) {
                this.estructurado.push([key]);
            } */
                    let number=0;
            for (const key in this.productos[0]) {
                this.productosKey.push([key]);

                let recogerPalabra=key;
                let recogercadenas=[];
                
                let separarFEcha=this.productos[0]['Fecha'].split("/");

                let estructurarFEcha=separarFEcha[2]+"-"+separarFEcha[1]+"-"+separarFEcha[0];
                //console.log("estructurarFEcha",estructurarFEcha);
                if(number==0){

                  //  console.log("estructura",estructurarFEcha,"database",this.database)
                    this.imprimirService.getAnexo(estructurarFEcha,this.database).subscribe(resp=>{
                        //console.log("resp",resp);
                     
                        try {
                            if(resp[0]['fecha_anexo']===undefined){
                                this.anexo=new Date();
                            }else{
                                this.anexo=resp[0]['fecha_anexo'];
                            }
                        } catch (error) {
                            this.anexo=new Date();
                        }
                        
                        
                       });
                       number++;
                }else{

                }
              

                if(key=="id"){

                }else{
              
                    this.myMap.set(key,this.productos[0][key]);
                    if(recogerPalabra.includes("_")){
                       
                        recogercadenas=key.split("_");
                        recogerPalabra=this.jsUcfirst(recogercadenas[0])+" "+recogercadenas[1];
                        recogerPalabra=recogerPalabra.replace("_"," ");
                    }
                    try{
                        if (Number.isInteger(parseInt(recogerPalabra.substring(recogerPalabra.length - 1, recogerPalabra.length)))){
                           // console.log("true");
                            
                        recogerPalabra=this.jsUcfirst(recogerPalabra.slice(0,recogerPalabra.length - 1)) +" "+recogerPalabra.slice(-1);
                        }
                    }catch(error){
    
                    }
                  
                    recogerPalabra=this.jsUcfirst(recogerPalabra);
                   
                        this.estructurado.push(recogerPalabra+" : "+this.productos[0][key]);
                    
    
                    //this.estructurado.push(recogerPalabra+" : "+this.productos[0][key]);
                }
               
            }
           
            //console.log("estructurado", this.estructurado);

        });
     
    }
     jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}
imprimir(){
    let o = {
        filename: 'documento.doc',
       area: 'div.googoose',
       margins: '1in',
       headermargin: '0.5in',
       display: 'Print',
    /*    lang: 'es-ES', */
       lang: 'es-ES',
       download: true
       };
      //debugger;
       
    
      let res = $(document).googoose(o);
}
exportHTML(){
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
         "xmlns:w='urn:schemas-microsoft-com:office:word' "+
         "xmlns='http://www.w3.org/TR/REC-html40'>"+
         "<head><meta charset='utf-8'>"+
         "<style></style>"+
         "<title>Export HTML to Word Document with JavaScript</title></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header+document.getElementById("source-html").innerHTML+footer;
    
    var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = 'document.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);
 }

 Export2Doc(){
     //this.convertImagesToBase64();
    
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
    +"<style>p,div,h1{font-family: Arial !important';} p{font-size:20px;display:inline-block;padding:4px;}  table{border: 1px solid black;} </style>"
    +"</head><body > <div style=' font-family: Arial !important;'>";
    var postHtml = "</div></body></html>";
    var html = preHtml+document.getElementById('source-html').innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    let filename="";
    // Specify file name
    filename = filename?filename+'.doc':'informe.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
}

sustituirAcentos(cadena:String){
//console.log("cadena",cadena.length);
var especiales=["Á","É","Í","Ó","Ú","ñ","á","é","í","ó","ú"];
let sustitutos=["&Aacute","&Eacute","IAacute","&Oacute","&Uacute","&ntilde","&aacute","&eacute","&iacute","&oacute","&uacute"];
let nuevaCadena="";
let discriminador=false;
let numero=cadena.length;

for (let index = 0; index < numero; index++) {
    discriminador=false;
    for (let j = 0; j < especiales.length; j++) {
        
       if((cadena.charAt(index))==especiales[j]){
        nuevaCadena+=sustitutos[j];
        discriminador=true;
        
       } 
    }
    //console.log("charAt"+cadena.charAt(index));
    if(discriminador){

    }else{
        nuevaCadena+=cadena.charAt(index);
    }
     
}
return nuevaCadena;

}

 convertImagesToBase64 () {
 
    let regularImages = document.getElementById("source-html").querySelectorAll("img");
    
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    [].forEach.call(regularImages, function (imgElement) {
      // preparing canvas for drawing
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.width = imgElement.width;
      canvas.height = imgElement.height;
      ctx.drawImage(imgElement, 0, 0);
      // by default toDataURL() produces png image, but you can also export to jpeg
      // checkout function's documentation for more details
      var dataURL = canvas.toDataURL();
    
      
      imgElement.setAttribute('src', dataURL);
    })
    canvas.remove();
  }

  cerrar(){
      this.cerrarVentana.emit({ closeWindow:false});
  }

}